@if (asset) {
<nav class="container crumb-bar">
	<a class="crumb-item" [routerLink]="['../../../../']">My {{brand.fleetPlural}}</a>
	<span class="crumb-item">&rsaquo;</span>
	<a class="crumb-item" [routerLink]="['../../']">{{fleet?.fleet_name}}</a>
	<span class="crumb-item">&rsaquo;</span>
	<span class="crumb-item active">{{asset?.asset_name}}@if (asset && asset.asset_serial_number) {
		<span>
			({{asset.asset_serial_number}})</span>
		}</span>
</nav>
}

<!-- No longer sticky -->
@if (asset) {
<div class="nonsticky-header">
	@if (asset) {
	<div class="container">
		<div class="row">
			<div class="col-lg-4 overview mb-3-md-down">
				<div class="section-title">{{asset.alt_asset_term || brand.assetSingular}} Overview</div>
				<div class="row">
					<div class="col-12 col-sm-6 col-lg-12">
						<!-- Organization -->
						@if (asset.fleet_id === 0 || api.user?.support) {
						<div><b>Organization:</b> {{asset.organization_name}}</div>
						}
						<!-- Fleet -->
						<div><b>{{brand.fleetSingular}}:</b> {{asset.fleet_name || fleet.fleet_name}}</div>
						<!-- Asset -->
						<div><b>{{asset.alt_asset_term || brand.assetSingular}}:</b> <span class="focal">{{asset.asset_name}}</span></div>
						<!-- Serial -->
						@if (asset.asset_serial_number) {
						<div><b>{{asset.alt_asset_term || brand.assetSingular}} Serial:</b> <span class="focal">{{asset.asset_serial_number}}</span></div>
						}
						<!-- Server ID -->
						<div><b>Server ID:</b> <span class="focal">{{asset.obcu_serial_number}}</span></div>
						<!-- Asset type -->
						<div><b>{{asset.alt_asset_term || brand.assetSingular}} Type:</b> {{asset.asset_type_name | removeBaseline}}</div>
						<!-- Config version -->
						@if (asset.latest_assembly_version) {
						<div><b>OBCU Config Version:</b> {{asset.latest_assembly_version}}</div>
						}
					</div>
					<div class="col-12 col-sm-6 col-lg-12">
						<hr class="d-block d-sm-none d-lg-block" />
						@if (!asset.is_fixed) {
						<table>
							@if (lastOperation) {
							<tbody>
								@if (lastOperation.flight_time > 0) {
								<tr>
									<td class="column-spacer">Last {{brand.flightTime}}:</td>
									<td class="value">{{lastOperation.flight_time | runtime}}</td>
								</tr>
								}
								@if (asset.flight_time !== null) {
								<tr>
									<td class="column-spacer">Total {{brand.flightTime}}:</td>
									<td class="value">{{asset.flight_time | runtime}}</td>
								</tr>
								}
								<tr>
									<td>&nbsp;</td>
									<td>&nbsp;</td>
								</tr>
							</tbody>
							}
							@if (components && components.engine && components.engine.length > 0) {
							<tbody>
								@for (engine of components.engine; track engine) {
								<tr>
									<td class="column-spacer">Engine {{engine.name}} HI:</td>
									<td class="value">
										{{(engine.state ? engine.state.filtered_hi : undefined) | number : "1.2-2" | ifempty : "N/A"}}</td>
								</tr>
								}
							</tbody>
							}
						</table>
						}
					</div>
				</div>
			</div>
			<div class="col-lg-8 summary mt-3 mt-lg-0">
				<div class="section-title">Diagnostic Summary</div>
				<div class="summary-grid">
					<!-- Rotor Track + Balance -->
					@if (api.user.hide_rtb !== 1 && !asset.is_fixed) {
					<div class="summary-item">
						<div class="item-title">Rotor Track + Balance</div>
						<div class="item-description">Main Rotor Vibration Magnitude</div>
						<div class="item-value" [class]="itemHealth?.Foreground('rtb')">
							{{asset.rtbmax | number : "1.2-2" | ifempty : "N/A"}}
						</div>
						<div class="item-detail">
							@if (asset.defaultvshaft) {
							<div>
								Shaft: <span class="value">{{asset.defaultvshaft}}</span>
							</div>
							}
						</div>
						<div class="item-selector">
							<button routerLink="rtb" routerLinkActive="selected" preventNavIfSelected class="button block health">
								<div class="ms-3">
									<span class="d-none d-md-inline-block">Show</span> Details
								</div>
								<app-health-status-indicator [item]="asset" component="rtb"></app-health-status-indicator>
							</button>
						</div>
						<div class="item-health-line" [class]="itemHealth?.Background('rtb')"></div>
					</div>
					}
					<!-- RTB not available -->
					@if (api.user.hide_rtb === 1 || asset.is_fixed) {
					<div class="summary-item disabled">
						<div class="item-title">Rotor Track + Balance</div>
						<div class="item-description">Main Rotor Vibration Magnitude</div>
						<div class="item-value">N/A</div>
						<div class="item-detail"></div>
						<div class="item-selector">
							<button class="button block" disabled>Not Available</button>
						</div>
						<div class="item-health-line status-blank-bg"></div>
					</div>
					}
					<!-- FDM + Exceedances -->
					@if (api.user.hide_fdm !== 1 && !asset.is_fixed) {
					<div class="summary-item">
						<div class="item-title">FDM + Exceedances</div>
						<div class="item-description">Total Unacknowledged Exceedances</div>
						<div class="item-value" [class]="itemHealth?.Foreground('fdm')">
							{{asset.exceedancecount}}
						</div>
						<div class="item-detail"> </div>
						<div class="item-selector">
							<button routerLink="fdm" routerLinkActive="selected" preventNavIfSelected class="button block health">
								<div class="ms-3">
									<span class="d-none d-md-inline-block">Show</span> Details
								</div>
								<app-health-status-indicator [item]="asset" component="fdm"></app-health-status-indicator>
							</button>
						</div>
						<div class="item-health-line" [class]="itemHealth?.Background('fdm')"></div>
					</div>
					}
					<!-- FDM not available -->
					@if (api.user.hide_fdm === 1 || asset.is_fixed) {
					<div class="summary-item disabled">
						<div class="item-title">FDM + Exceedances</div>
						<div class="item-description">Total Unacknowledged Exceedances</div>
						<div class="item-value">N/A</div>
						<div class="item-detail"></div>
						<div class="item-selector">
							<button class="button block" disabled>Not Available</button>
						</div>
						<div class="item-health-line status-blank-bg"></div>
					</div>
					}
					<!-- Mechanical Diagnostics -->
					@if (api.user.hide_mech !== 1) {
					<div class="summary-item">
						<div class="item-title">Mechanical Diagnostics</div>
						<div class="item-description">Highest HI</div>
						<div class="item-value" [class]="itemHealth?.Foreground('md')">
							{{asset.mdmax | number : "1.2-2" | ifempty : "N/A"}}
						</div>
						<div class="item-detail">
							@if (asset.rulmin) {
							<div class="rul-shortest">Shortest RUL:
								<span class="value">{{asset.rulmin | number : "1.2-2"}} hr</span>
							</div>
							}
							@if (asset.rulmin && worstrulcomponent) {
							<div class="rul-component">
								<a [routerLink]="['md', worstrulcomponent.id]" class="underline">Component: <span class="value">{{worstrulcomponent.name}}</span></a>
							</div>
							}
							@if (!(asset.rulmin && worstrulcomponent) && worsthicomponent) {
							<div class="rul-component">
								<a [routerLink]="['md', worsthicomponent.id]" class="underline">Component: <span class="value">{{worsthicomponent.name}}</span></a>
							</div>
							}
						</div>
						<div class="item-selector">
							<button routerLink="md" routerLinkActive="selected" preventNavIfSelected class="button block health">
								<div class="ms-3">
									<span class="d-none d-md-inline-block">Show</span> Details
								</div>
								<app-health-status-indicator [item]="asset" component="md"></app-health-status-indicator>
							</button>
						</div>
						<div class="item-health-line" [class]="itemHealth?.Background('md')"></div>
					</div>
					}
					<!-- MD not available -->
					@if (api.user.hide_rtb === 1) {
					<div class="summary-item disabled">
						<div class="item-title">Mechanical Diagnostics</div>
						<div class="item-description">Highest HI</div>
						<div class="item-value">N/A</div>
						<div class="item-detail"></div>
						<div class="item-selector">
							<button class="button block" disabled>Not Available</button>
						</div>
						<div class="item-health-line status-blank-bg"></div>
					</div>
					}
				</div>
			</div>
		</div>
	</div>
	}
</div>
}

@if (asset && components) {
<div #assetDetail class="container asset-detail">
	<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
</div>
}

@if (asset === undefined) {
<div class="loading-status">
	<div class="logo-spin"></div>
	Loading asset...
</div>
}